import gql from 'graphql-tag';

export const LINKEDIN_SOCIAL_AUTHORIZATION_QUERY = gql`
  query LinkedinSocialAuthorization {
    linkedinSocialAuthorization {
      status
    }
  }
`;

export const FRAGMENT_LINKEDIN_SOCIAL_AD_ACCOUNT = gql`
  fragment LinkedinUserAdAccount on LinkedinUserAdAccount {
    id
    name
  }
`;
